import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import { Box, Typography } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import { customTextColor } from "../../../utils/const";
import { useState } from "react";
import { StylesContext } from "@mui/styles";
import styles from "../InternalTracker.module.css";
import { IoIosArrowUp } from "react-icons/io";
import { BsHourglassSplit } from "react-icons/bs";
import { BsFileEarmarkCheck } from "react-icons/bs";
import { LiaHeadsetSolid } from "react-icons/lia";
import { PiOfficeChair } from "react-icons/pi";
import { BsFileEarmarkExcel } from "react-icons/bs";

function SideDrawer({ handleClose, show }) {
  const [showAllData, setShowAllData] = useState("0");

  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "470px",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Offcanvas.Title style={{ fontWeight: "600", color: customTextColor }}>
          David Miller - Submission History
        </Offcanvas.Title>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          <span>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                {" "}
                Position : <b>Full stack Developer at Georgia, GA</b>{" "}
              </span>
              <BsHourglassSplit style={{ fontSize: "24px" }} />
            </Typography>

            <Typography>
              Client : <b>Master Card Inc</b>
            </Typography>
            <Typography>
              Date : <b>11 August 2024, 11:30 PM</b>
            </Typography>
            <Typography
              sx={
                showAllData === "1"
                  ? {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
                  : {
                      marginBottom: "0 !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
              }
            >
              <span>
                {" "}
                Status : <b>Waiting</b>{" "}
              </span>
              {(showAllData === "0" ||
                showAllData === "2" ||
                showAllData === "3") && (
                <IoIosArrowDown onClick={() => setShowAllData("1")} />
              )}
            </Typography>
            {showAllData === "1" && (
              <>
                <Typography sx={{ marginTop: "20px" }}>
                  BDM/Account Manager Details
                </Typography>
                <Typography>
                  Name : <b>Ramesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>ramesh@rkmsoft.com</b>{" "}
                  </span>{" "}
                </Typography>

                <Typography sx={{ marginTop: "20px" }}>
                  Employer Details
                </Typography>
                <Typography>
                  Name : <b>Dinesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>dinesh@mulesoftking.com</b>{" "}
                  </span>{" "}
                  <IoIosArrowUp onClick={() => setShowAllData("0")} />
                </Typography>
              </>
            )}
          </span>
          <hr />
        </Box>
        <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          <span>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                {" "}
                Position : <b> Full Stack Developer at Dallas Taxes, TX</b>{" "}
              </span>
              <BsFileEarmarkCheck style={{ fontSize: "24px" }} />
            </Typography>
            <Typography>
              Client : <b>Capital One</b>
            </Typography>
            <Typography>
              Date : <b>11 August 2024, 11:30 PM</b>
            </Typography>
            <Typography
              sx={
                showAllData === "2"
                  ? {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
                  : {
                      marginBottom: "0 !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
              }
            >
              <span>
                {" "}
                Status : <b>Submitted to Client</b>{" "}
              </span>
              {(showAllData === "0" ||
                showAllData === "1" ||
                showAllData === "3") && (
                <IoIosArrowDown onClick={() => setShowAllData("2")} />
              )}
            </Typography>
            {showAllData === "2" && (
              <>
                <Typography sx={{ marginTop: "20px" }}>
                  BDM/Account Manager Details
                </Typography>
                <Typography>
                  Name : <b>Ramesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>ramesh@rkmsoft.com</b>{" "}
                  </span>{" "}
                </Typography>

                <Typography sx={{ marginTop: "20px" }}>
                  Employer Details
                </Typography>
                <Typography>
                  Name : <b>Dinesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>dinesh@mulesoftking.com</b>{" "}
                  </span>{" "}
                  <IoIosArrowUp onClick={() => setShowAllData("0")} />
                </Typography>
              </>
            )}
          </span>
          <hr />
        </Box>
        <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          <span>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                {" "}
                Position : <b>Full Stack Developer at California, CA</b>{" "}
              </span>
              <LiaHeadsetSolid style={{ fontSize: "24px" }} />
            </Typography>
            <Typography>
              Client : <b>State Client</b>
            </Typography>
            <Typography>
              Date : <b>11 August 2024, 11:40 PM</b>
            </Typography>
            <Typography
              sx={
                showAllData === "3"
                  ? {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
                  : {
                      marginBottom: "0 !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
              }
            >
              <span>
                Status : <b>1st Round Interview</b>{" "}
              </span>
              {(showAllData === "0" ||
                showAllData === "2" ||
                showAllData === "1") && (
                <IoIosArrowDown onClick={() => setShowAllData("3")} />
              )}
            </Typography>
            {showAllData === "3" && (
              <>
                <Typography sx={{ marginTop: "20px" }}>
                  BDM/Account Manager Details
                </Typography>
                <Typography>
                  Name : <b>Ramesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>ramesh@rkmsoft.com</b>{" "}
                  </span>{" "}
                </Typography>

                <Typography sx={{ marginTop: "20px" }}>
                  Employer Details
                </Typography>
                <Typography>
                  Name : <b>Dinesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>dinesh@mulesoftking.com</b>{" "}
                  </span>{" "}
                  <IoIosArrowUp onClick={() => setShowAllData("0")} />
                </Typography>
              </>
            )}
          </span>
          <hr />
        </Box>
        <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          <span>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                {" "}
                Position : <b>Full Stack Developer at Washington, DC</b>
              </span>
              <LiaHeadsetSolid style={{ fontSize: "24px" }} />
            </Typography>
            <Typography>
              Client : <b>Humana Healthcare</b>
            </Typography>
            <Typography>
              Date : <b>11 August 2024, 10:40 PM</b>
            </Typography>
            <Typography
              sx={
                showAllData === "3"
                  ? {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
                  : {
                      marginBottom: "0 !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
              }
            >
              <span>
                Status : <b>2nd Round Interview</b>{" "}
              </span>
              {(showAllData === "0" ||
                showAllData === "2" ||
                showAllData === "1") && (
                <IoIosArrowDown onClick={() => setShowAllData("4")} />
              )}
            </Typography>
            {showAllData === "4" && (
              <>
                <Typography sx={{ marginTop: "20px" }}>
                  BDM/Account Manager Details
                </Typography>
                <Typography>
                  Name : <b>Ramesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>ramesh@rkmsoft.com</b>{" "}
                  </span>{" "}
                </Typography>

                <Typography sx={{ marginTop: "20px" }}>
                  Employer Details
                </Typography>
                <Typography>
                  Name : <b>Dinesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>dinesh@mulesoftking.com</b>{" "}
                  </span>{" "}
                  <IoIosArrowUp onClick={() => setShowAllData("0")} />
                </Typography>
              </>
            )}
          </span>
          <hr />
        </Box>
        <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          <span>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                {" "}
                Position : <b>Full Stack Developer at Washington, DC</b>{" "}
              </span>
              <LiaHeadsetSolid style={{ fontSize: "24px" }} />
            </Typography>
            <Typography>
              Client : <b>Capital One</b>
            </Typography>
            <Typography>
              Date : <b>11 August 2024, 10:40 PM</b>
            </Typography>
            <Typography
              sx={
                showAllData === "3"
                  ? {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
                  : {
                      marginBottom: "0 !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
              }
            >
              <span>
                Status : <b>3rd Round Interview</b>{" "}
              </span>
              {(showAllData === "0" ||
                showAllData === "2" ||
                showAllData === "1") && (
                <IoIosArrowDown onClick={() => setShowAllData("5")} />
              )}
            </Typography>
            {showAllData === "5" && (
              <>
                <Typography sx={{ marginTop: "20px" }}>
                  BDM/Account Manager Details
                </Typography>
                <Typography>
                  Name : <b>Ramesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>ramesh@rkmsoft.com</b>{" "}
                  </span>{" "}
                </Typography>

                <Typography sx={{ marginTop: "20px" }}>
                  Employer Details
                </Typography>
                <Typography>
                  Name : <b>Dinesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>dinesh@mulesoftking.com</b>{" "}
                  </span>{" "}
                  <IoIosArrowUp onClick={() => setShowAllData("0")} />
                </Typography>
              </>
            )}
          </span>
          <hr />
        </Box>
        <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          <span>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                {" "}
                Position : <b> Full Stack Developer at Dallas Taxes, TX</b>{" "}
              </span>
              <PiOfficeChair style={{ fontSize: "24px" }} />
            </Typography>
            <Typography>
              Client : <b>Capital One</b>
            </Typography>
            <Typography>
              Date : <b>11 August 2024, 11:30 PM</b>
            </Typography>
            <Typography
              sx={
                showAllData === "2"
                  ? {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
                  : {
                      marginBottom: "0 !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
              }
            >
              <span>
                {" "}
                Status : <b>Confirmed</b>{" "}
              </span>
              {(showAllData === "0" ||
                showAllData === "1" ||
                showAllData === "3") && (
                <IoIosArrowDown onClick={() => setShowAllData("6")} />
              )}
            </Typography>
            {showAllData === "6" && (
              <>
                <Typography sx={{ marginTop: "20px" }}>
                  BDM/Account Manager Details
                </Typography>
                <Typography>
                  Name : <b>Ramesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>ramesh@rkmsoft.com</b>{" "}
                  </span>{" "}
                </Typography>

                <Typography sx={{ marginTop: "20px" }}>
                  Employer Details
                </Typography>
                <Typography>
                  Name : <b>Dinesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>dinesh@mulesoftking.com</b>{" "}
                  </span>{" "}
                  <IoIosArrowUp onClick={() => setShowAllData("0")} />
                </Typography>
              </>
            )}
          </span>
          <hr />
        </Box>
        <Box sx={{ color: customTextColor }} className={styles.canvas_body}>
          <span>
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span>
                {" "}
                Position : <b> Full Stack Developer at Dallas Taxes, TX</b>{" "}
              </span>
              <BsFileEarmarkExcel style={{ fontSize: "24px" }} />
            </Typography>
            <Typography>
              Client : <b>Capital One</b>
            </Typography>
            <Typography>
              Date : <b>11 August 2024, 11:30 PM</b>
            </Typography>
            <Typography
              sx={
                showAllData === "2"
                  ? {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
                  : {
                      marginBottom: "0 !important",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }
              }
            >
              <span>
                {" "}
                Status : <b>Rejected</b>{" "}
              </span>
              {(showAllData === "0" ||
                showAllData === "1" ||
                showAllData === "3") && (
                <IoIosArrowDown onClick={() => setShowAllData("7")} />
              )}
            </Typography>
            {showAllData === "7" && (
              <>
                <Typography sx={{ marginTop: "20px" }}>
                  BDM/Account Manager Details
                </Typography>
                <Typography>
                  Name : <b>Ramesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>ramesh@rkmsoft.com</b>{" "}
                  </span>{" "}
                </Typography>

                <Typography sx={{ marginTop: "20px" }}>
                  Employer Details
                </Typography>
                <Typography>
                  Name : <b>Dinesh Gandhi</b>{" "}
                </Typography>
                <Typography
                  sx={{
                    marginBottom: "0 !important",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span>
                    {" "}
                    E-Mail ID: <b>dinesh@mulesoftking.com</b>{" "}
                  </span>{" "}
                  <IoIosArrowUp onClick={() => setShowAllData("0")} />
                </Typography>
              </>
            )}
          </span>
          <hr />
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SideDrawer;
